import React, { useEffect, useState } from 'react'
import { enums } from '../../../constants'
import utils, { getMessage } from '../../../utils'
import LtsDropdownIdValue from '../../../components/lottus/lts-dropdown-id-value'
import storage from '../../../services/stoage.service'
import LtsCurrency from '../../../components/lottus/lts-currency'
import LtsInputNumber from '../../../components/lottus/lts-input-number'

export default function ConfigDescontoCaixa(props) {
  const messages = storage.getAppLabels('configuracaoboleto')

  const parseValue = (value) => {
    if (!value) return {}
    if (typeof value === 'object') return value
    if (typeof value !== 'string') return {}
    try {
      return JSON.parse(value) || {}
    } catch (e) {
      return {}
    }
  }

  const data = parseValue(props.value)

  const tipoDescontoId = data?.tipoDesconto
  const [tipoDesconto, setTipoDesconto] = useState(null)

  useEffect(() => {
    setTipoDesconto(enums.TipoDescontoCaixa.find((opt) => opt.id === tipoDescontoId) || null)
  }, [tipoDescontoId])

  const emitChange = (next) => {
    if (!props.onChange) return
    props.onChange(JSON.stringify(next))
  }

  const update = (field, value) => {
    emitChange({
      ...data,
      tipoDesconto: resolvedTipoDescontoId,
      [field]: value,
    })
  }

  const resolvedTipoDesconto =
    tipoDesconto || enums.TipoDescontoCaixa.find((opt) => opt.id === data?.tipoDesconto) || null
  const resolvedTipoDescontoId = resolvedTipoDesconto?.id ?? data?.tipoDesconto ?? 'ISENTO'

  const showValorDias = resolvedTipoDescontoId !== 'ISENTO'

  const onChangeTipoDesconto = (opt) => {
    const nextTipo = opt || null
    const nextTipoId = nextTipo?.id ?? null

    setTipoDesconto(nextTipo)

    if (nextTipoId === 'ISENTO') {
      emitChange({
        ...data,
        tipoDesconto: nextTipoId,
        valorDesconto: null,
        diasDesconto: null,
      })
      return
    }

    emitChange({ ...data, tipoDesconto: nextTipoId })
  }

  return (
    <>
      <div className="p-col-12">
        <LtsDropdownIdValue
          value={resolvedTipoDesconto}
          options={enums.TipoDescontoCaixa}
          onChange={onChangeTipoDesconto}
          optionLabel="value"
          optionValue={(v) => v}
          dataKey="id"
          name="tipoDescontoCaixa"
          label={utils.getMessage(messages, 'configuracaoboleto.label.tipodesconto')}
        />
      </div>

      {showValorDias && (
        <>
          <div className="p-col-12">
            <LtsCurrency
              value={data.valorDesconto}
              onChange={(e) => update('valorDesconto', e)}
              name="valorDescontoCaixa"
              label={getMessage(messages, 'configuracaoboleto.label.valordesconto')}
            />
          </div>
          <div className="p-col-12">
            <LtsInputNumber
              name="diasDescontoCaixa"
              value={data.diasDesconto}
              onChange={(e) => update('diasDesconto', e)}
              label={getMessage(messages, 'configuracaoboleto.label.diasdesconto')}
              format={false}
            />
          </div>
        </>
      )}
    </>
  )
}
